<template>
  <div class="globalHead" >
    <div class="sitelogo" >
      <router-link to="/"><img class="" src="/img/titleH1.png" srcset="/img/titleH1@2x.png 2x" alt="東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。 - This Cruel Yet Beloved World -" /></router-link>
    </div><!-- /sitelogo-->
    <nav class="globalMenuArea">
      <ul class="globalMenu pc">
        <li class="exhTxt"><router-link to="/artworks" :class="{ location: isSelected('/artworks') || isSelected('/exhibitors') }">作品展<span>示</span></router-link></li>
        <li class="exhTxt"><router-link to="/specials" :class="{ location: isSelected('/specials') }">特別展<span>示</span></router-link></li>
        <li><router-link to="/talkshows" :class="{ location: isSelected('/talkshows') }">オンライントークショー</router-link></li>
        <li><router-link to="/photobook" :class="{ location: isSelected('/photobook') }">公式写真集</router-link></li>
      </ul>
      <div class="globalMenuSp sp">
        <a href="javascript:void(0);" @click="openSpMenu"><i></i><i></i><i></i></a>
      </div>
    </nav><!-- /globalMenuArea-->
    <SpMenu
      :isOpen.sync="isSpMenuOpen"
    />
  </div><!-- /globalHead-->
</template>

<script>
import SpMenu from '@/components/modules/SpMenu.vue'

export default {
  components: {
    SpMenu
  },
  data () {
    return {
      isSpMenuOpen: false,
      currentScrollPosition: 0
    }
  },
  watch: {
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isSpMenuOpen: function (val, oldVal) {
      if (!val) {
        this.bodyFixedOff()
      }
    }
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    openSpMenu () {
      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.isSpMenuOpen = true
    },
    // メインページスクロール固定処理設定
    bodyFixedOn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        this.currentScrollPosition = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.currentScrollPosition}px`
      } else {
        body.style.overflow = 'hidden'
      }
    },
    // メインページスクロール固定処理解除
    bodyFixedOff () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }
    }
  }
}
</script>
